/** XeAgents.ai**/

/**
 * The signup offer, in one place because it is now stated on five surfaces:
 * the announcement bar, the navbar button, the hero card, the offer band and
 * the pricing cards' free tier. A number that drifts between them reads as a
 * bait-and-switch.
 *
 * MUST MATCH the free plan's included_credits in the plans table. Moved from
 * 50 to 100 by migration 0076 (it had been settled at 50 by 0069); registration
 * grants from the plan row, so the number is stated in one place and honoured
 * from it.
 */
export const FREE_VOICE_CREDITS = 100;

/** "100 Free Voice Credits" - the offer as the buttons and headings say it. */
export const FREE_CREDITS_LABEL = `${FREE_VOICE_CREDITS} Free Voice Credits`;

/** The three qualifiers that appear under every statement of the offer. */
export const FREE_CREDITS_TERMS = [
  "No credit card required",
  "No setup fee",
  "Start in minutes",
] as const;
